<template>
  <div class="sp-template plate-template">
    <div class="h-title">编辑批次</div>
    <el-card class="box-card">
      <el-form :model="editForm" size="small" label-width="110px">
        <div class="plate-content left-padding">
          <div class="list-items">
            <div class="item">
              <div class="label">批&nbsp;&nbsp;次&nbsp;&nbsp;号</div>
              <div class="text">{{editForm.id}}</div>
            </div>
            <div class="item">
              <div class="label">箱　　数</div>
              <div class="text">{{editForm.qty}}</div>
            </div>
            <div class="item">
              <div class="label">毛重(kg)</div>
              <div class="text">{{editForm.weight?toFixed(editForm.weight,3):""}}</div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">体积(kg)</div>
              <div class="text">{{editForm.volume?toFixed(editForm.volume,6):""}}</div>
            </div>
            <div class="item">
              <div class="label">时　　效</div>
              <div class="text">{{editForm.orderPrescription}}</div>
            </div>
            <div class="item">
              <div class="label">是否查验</div>
              <div class="text"><el-switch v-model="editForm.batchAttribute.whether_the_inspection"></el-switch></div>
            </div>
          </div>
        </div>
        <div class="plate-content">
          <div class="form-items">
            <div class="form-item">
              <el-form-item label="航空公司" v-if="editForm.channelType === 'AIR_SHIPPING'">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.airlines"></el-input>
              </el-form-item>
              <el-form-item label="航空单号"  v-if="editForm.channelType === 'AIR_SHIPPING'">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.air_waybill"></el-input>
              </el-form-item>
              <el-form-item label="船公司"  v-if="editForm.channelType === 'SEA_SHIPPING'">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.shipping_company"></el-input>
              </el-form-item>
              <el-form-item label="铁路公司"  v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.railway_companies"></el-input>
              </el-form-item>
              <el-form-item label="柜号"  v-if="editForm.channelType === 'SEA_SHIPPING'">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.air_waybill"></el-input>
              </el-form-item>
              <el-form-item label="提单重">
                <el-input size="small" type="number" v-model.lazy="editForm.batchAttribute.bill_of_lading_weight"></el-input>
              </el-form-item>
              <el-form-item label="计费重">
                <el-input size="small" type="number" v-model.lazy="editForm.batchAttribute.billing_weight"></el-input>
              </el-form-item>
              <!-- <el-form-item label="末端派送时间">
                <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.extraction_time" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item> -->
              <el-form-item label="代理公司">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.agency_company"></el-input>
              </el-form-item>
            </div>
            <div class="form-item">
              <el-form-item label="承运商">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.carriers"></el-input>
              </el-form-item>
              <el-form-item label="查验费收取(¥)">
                <el-input size="small" type="number" v-model.lazy="editForm.batchAttribute.inspection_fee_charged"></el-input>
              </el-form-item>
              <el-form-item label="查验通知">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.inspection_notice"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input size="small" type="textarea" :rows="2" v-model.lazy="editForm.remarks"></el-input>
              </el-form-item>
              <el-form-item label="查验费单" class="upload-buttons">
                <el-upload class="upload-demo" :on-change="uploadFileInspectionBill" :action="getFileUrl(editForm,'inspection_bill')" :auto-upload="false" :file-list="fileListI">
                  <el-button size="small">上传</el-button>
                </el-upload>
                <el-button size="small" class="download-btn" type="primary" plain @click="getDownloadUrl('inspection_bill')">下载</el-button>
              </el-form-item>
              <el-form-item label="费用凭证" class="upload-buttons">
                <el-upload class="upload-demo" :on-change="uploadFileCustomsFeeList" action="#" :auto-upload="false" :file-list="fileListC">
                  <el-button size="small">上传</el-button>
                </el-upload>
                <div v-for='(item,index) in customsFeeList' :key="index">
                  费用凭证 {{index+1}}
                  <el-button size="small" type="text" @click="getCustomsDownloadUrl(item)" title="下载">
                    <i class="el-icon-download"></i>
                  </el-button>
                  <el-button size="small" type="text" @click="deleteFile(index,item,editForm.id,'customs_fee_list')" title="删除"> 
                    <i class="el-icon-delete"></i>
                  </el-button>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="plate-content top-padding">


          <div class="table-operate__buttons" style="padding:0 20px;">
            <el-tabs v-model="tabStatus" @tab-click="searchTask">          
              <el-tab-pane label="轨迹一" name="0"></el-tab-pane>
              <el-tab-pane label="轨迹二" name="1"></el-tab-pane>
            </el-tabs>
            <div class="button-groups">
            </div>
          </div>

          <!-- 批次一 -->
          <div v-show="tabStatus == 0">
            <el-form-item label="出货">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_delivery_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">出货备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.delivery_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="国内查验">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">开始时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.notice_of_the_date_of_inspection" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">完成时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_notice_of_the_date_of_inspection" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">查验备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.notice_of_the_date_of_inspection_remark"></el-input>
                </div>
                <div class="group">
                  <span class="sub-label">查验通知文件</span>
                  <!-- <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.in_custody_remark" readonly></el-input> -->
                <el-upload
                        :ref="'uploadRef-chayan'"
                        action="#"
                        :limit="1"
                        list-type="text"
                        :on-change="fileChange1"
                        :on-remove="handleRemove1"
                        :auto-upload="false"
                        :file-list="fileList1['uploadRef-chayan']"
                        style="display: inline-block"
                      >
                        <el-button
                          slot="trigger"
                          size="small"  type="primary"
                          @click.native="fileButtonMark('uploadRef-chayan')"
                          > 上传  </el-button>
                      </el-upload>
                      <el-button v-if="editForm.batchAttribute.ba9 && editForm.batchAttribute.ba9!=0" size="small" 
                        type="success" @click="getAliyunUrl(editForm.batchAttribute.ba9)" style="margin-left:20px;">下载</el-button>

                </div>
              </div>
            </el-form-item>
            <el-form-item label="报关放行">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_customs_declaration_enddate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">报关备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.customs_declaration_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="起飞"  v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.departure_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_departure_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.departure_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="落地" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.landing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_landing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.landing_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="开船"  v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.sailing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_sailing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.sailing_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="开车"  v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.driving_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_driving_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.driving_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="到港" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.port_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_port_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.port_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="到达" v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.arrival_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_arrival_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.arrival_remark"></el-input>
                </div>
              </div>
            </el-form-item>
           
            <el-form-item label="卸船" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba0" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba1" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">卸船备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.ba2"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="拆板" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba13" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba14" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.ba15"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="国外查验">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">开始时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba3" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">完成时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba4" type="datetime" placeholder="完成时间" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.ba5"></el-input>
                </div>
                <div class="group">
                  <span class="sub-label">查验通知文件</span>
                  <!-- <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.notice_of_the_date_of_inspection_remark" readonly></el-input> -->
                <el-upload
                        :ref="'uploadRef-chayan2'"
                        action="#"
                        :limit="1"
                        list-type="text"
                        :on-change="fileChange1"
                        :on-remove="handleRemove1"
                        :auto-upload="false"
                        :file-list="fileList1['uploadRef-chayan2']"
                        style="display: inline-block"
                      >
                        <el-button
                          slot="trigger"
                          size="small"  type="primary"
                          @click.native="fileButtonMark('uploadRef-chayan2')"
                          > 上传  </el-button>
                      </el-upload>
                      <el-button v-if="editForm.batchAttribute.ba6 && editForm.batchAttribute.ba6!=0" size="small" 
                        type="success" @click="getAliyunUrl(editForm.batchAttribute.ba6)" style="margin-left:20px;">下载</el-button>

                </div>
              </div>
            </el-form-item>
            <el-form-item label="清关完成">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.inner_customs_clearance_enddate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.customs_clearance_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="提柜到仓" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba7" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.ba8"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="提货到仓" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba7" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.ba8"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="快递交承运商">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.ba11" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.ba12"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="快递提取">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.extraction_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.ba10"></el-input>
                </div>
              </div>
            </el-form-item>
          </div>
          <!-- 批次二 -->
          <div v-show="tabStatus == 1">
            <el-form-item label="订单号">
              <el-select v-model.lazy="editForm.orderIds2" multiple filterable clearable >
                <el-option v-for="(d, i) in theOrderIds" :key="i" :label="d" :value="d"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出货">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_delivery_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">出货备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.delivery_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="国内查验">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">开始时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.notice_of_the_date_of_inspection" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">完成时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_notice_of_the_date_of_inspection" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">查验备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.notice_of_the_date_of_inspection_remark"></el-input>
                </div>
                <div class="group">
                  <span class="sub-label">查验通知文件</span>
                  <!-- <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.in_custody_remark" readonly></el-input> -->
                <el-upload
                        :ref="'uploadRef-chayan3'"
                        action="#"
                        :limit="1"
                        list-type="text"
                        :on-change="fileChange1"
                        :on-remove="handleRemove1"
                        :auto-upload="false"
                        :file-list="fileList1['uploadRef-chayan3']"
                        style="display: inline-block"
                      >
                        <el-button
                          slot="trigger"
                          size="small"  type="primary"
                          @click.native="fileButtonMark('uploadRef-chayan3')"
                          > 上传  </el-button>
                      </el-upload>
                      <el-button v-if="editForm.batchAttribute2.ba9 && editForm.batchAttribute2.ba9!=0" size="small" 
                        type="success" @click="getAliyunUrl(editForm.batchAttribute2.ba9)" style="margin-left:20px;">下载</el-button>

                </div>
              </div>
            </el-form-item>
            <el-form-item label="报关放行">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_customs_declaration_enddate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">报关备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.customs_declaration_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="起飞"  v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.departure_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_departure_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.departure_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="落地" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.landing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_landing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.landing_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="开船"  v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.sailing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_sailing_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.sailing_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="开车"  v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.driving_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_driving_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.driving_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="到港" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.port_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_port_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.port_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="到达" v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.arrival_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_arrival_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.arrival_remark"></el-input>
                </div>
              </div>
            </el-form-item>
           
            <el-form-item label="卸船" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba0" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba1" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">卸船备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.ba2"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="拆板" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">计划时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba13" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba14" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.ba15"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="国外查验">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">开始时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba3" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">完成时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba4" type="datetime" placeholder="完成时间" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.ba5"></el-input>
                </div>
                <div class="group">
                  <span class="sub-label">查验通知文件</span>
                  <!-- <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.notice_of_the_date_of_inspection_remark" readonly></el-input> -->
                <el-upload
                        :ref="'uploadRef-chayan4'"
                        action="#"
                        :limit="1"
                        list-type="text"
                        :on-change="fileChange1"
                        :on-remove="handleRemove1"
                        :auto-upload="false"
                        :file-list="fileList1['uploadRef-chayan4']"
                        style="display: inline-block"
                      >
                        <el-button
                          slot="trigger"
                          size="small"  type="primary"
                          @click.native="fileButtonMark('uploadRef-chayan4')"
                          > 上传  </el-button>
                      </el-upload>
                      <el-button v-if="editForm.batchAttribute2.ba6 && editForm.batchAttribute2.ba6!=0" size="small" 
                        type="success" @click="getAliyunUrl(editForm.batchAttribute2.ba6)" style="margin-left:20px;">下载</el-button>

                </div>
              </div>
            </el-form-item>
            <el-form-item label="清关完成">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.inner_customs_clearance_enddate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.customs_clearance_remark"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="提柜到仓" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba7" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.ba8"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="提货到仓" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba7" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.ba8"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="快递交承运商">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.ba11" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.ba12"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="快递提取">
              <div class="inline-group">
                <div class="group">
                  <span class="sub-label">实际时间</span>
                  <el-date-picker size="small" v-model.lazy="editForm.batchAttribute2.extraction_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
                <div class="group">
                  <span class="sub-label">备注</span>
                  <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute2.ba10"></el-input>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- 上传文件 pod -->
        <div class="plate-content top-padding">

          <el-table :data="fbaCodeData" stripe border style="width: 1500px">
            <el-table-column prop="fbaCode" label="fba仓码" align="center"></el-table-column>
            <el-table-column prop="time1" label="预约送仓时间" align="center">
              <template slot-scope="scope">
                <el-date-picker size="small" v-model.lazy="scope.row.deliveredPlanAt" type="datetime" placeholder="预约送仓时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;">
                  </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="time2" label="实际送仓时间" align="center">
              <template slot-scope="scope">
                <el-date-picker size="small" v-model.lazy="scope.row.deliveredAt" type="datetime" placeholder="pod回传时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;">
                  </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="POD" width="400" align="center">
              <template slot-scope="scope">

                <span v-if="scope.row.podOssKey && scope.row.podOssKey!=0">{{scope.row.podOssKey}}</span>

                <el-upload
                        :ref="'uploadRef' + scope.row.fbaCode"
                        action="#"
                        :limit="1"
                        list-type="text"
                        :on-change="fileChange1"
                        :on-remove="handleRemove1"
                        :auto-upload="false"
                        :file-list="fileList1[scope.row.fbaCode]"
                        style="display: inline-block"
                      >
                        <el-button
                          slot="trigger"
                          size="small"  type="primary"
                          @click.native="fileButtonMark(scope.row.fbaCode)"
                          > <span v-if="scope.row.podOssKey && scope.row.podOssKey!=0">重新上传</span><span v-else>上传</span>  </el-button>
                      </el-upload>

                      <el-button v-if="!!scope.row.podUrl" size="small" type="success" @click="openUrl(scope.row.podUrl)" style="margin-left:20px;">下载</el-button>

                <!-- <el-button size="small" @click="editFileDownloadPop(scope.row)">上传</el-button> -->
              </template>
            </el-table-column>

            <el-table-column prop="expose" label="是否显示给客户看" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.expose">是否显示给客户看</el-checkbox>
              </template>
            </el-table-column>

          </el-table>



        </div>

        <!-- seller-tracking轨迹 -->
        <div class="plate-content top-padding">
          <div style="font-size: 17px;font-weight: 700;margin: 0 0 20px 20px;color: #3333ff;">客户端轨迹</div>

          <el-table :data="sellerTracks.trackings1" stripe border style="width: 1500px" v-show="tabStatus == 0">
            <el-table-column prop="eventName" label="轨迹" align="center"></el-table-column>
            <el-table-column prop="detail" label="备注" align="center"></el-table-column>
            <el-table-column prop="at" label="计划时间" align="center"></el-table-column>
            <el-table-column prop="actualAt" label="实际时间" align="center"></el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="small" type="danger" @click="delTrack(scope.row)" style="margin-left:20px;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-table :data="sellerTracks.trackings2" stripe border style="width: 1500px" v-show="tabStatus == 1">
            <el-table-column prop="eventName" label="轨迹" align="center"></el-table-column>
            <el-table-column prop="detail" label="备注" align="center"></el-table-column>
            <el-table-column prop="at" label="计划时间" align="center"></el-table-column>
            <el-table-column prop="actualAt" label="实际时间" align="center"></el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="small" type="danger" @click="delTrack(scope.row)" style="margin-left:20px;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
        
      </el-form>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="$router.go(-1)">返 回</el-button>
      <el-button type="primary" @click="handleSave" v-show="!isDeleted">确 定</el-button>
    </div>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default {
  name: 'EditBatchOperation',
  data() {
    return {
      isDeleted: false, // 是否删除过轨迹
      theOrderIds: [],
      currentFileStr: '', // 当前文件标记
      fbaCodeData:[],
      fileList1: {},
      fileEditForm: {
        orderId: '',
        name: '',
        key: ''
      },
      tabStatus: 0,
      id: "",
      editForm: {
        orderIds1: [],
        orderIds2: [],
        id: "",
        qty: "",
        weight: "",
        volume: "",
        remarks: "",
        orderPrescription: "",
        channelType: "",
        batchAttribute: {
          whether_the_inspection: false,
          airlines: "",
          air_waybill: "",
          shipping_company: "",
          railway_companies: "",
          extraction_company: "",
          bill_of_lading_weight: "",
          billing_weight: "",
          extraction_time: "",
          agency_company: "",
          carriers: "",
          inspection_fee_charged: "",
          inspection_notice: "",
          departure_time: "",
          inner_departure_time: "",
          sailing_time: "",
          inner_sailing_time: "",
          driving_time: "",
          inner_driving_time: "",
          landing_time: "",
          inner_landing_time: "",
          port_time: "",
          inner_port_time: "",
          arrival_time: "",
          inner_arrival_time: "",
          completion_time_of_the_goods: "",
          inner_completion_time_of_the_goods: "",
          delivery_time: "",
          inner_delivery_time: "",
          transport_vehicles: "",
          transport_drivers: "",
          customs_declaration_enddate: "",
          inner_customs_declaration_enddate: "",
          customs_declaration_customs: "",
          customs_clearance_enddate: "",
          inner_customs_clearance_enddate: "",
          customs_clearance_customs: "",
          release_date: "",
          inner_release_date: "",
          delivery_time_to_warehouse: "",
          inner_delivery_time_to_warehouse: "",
          time_in_custody: "",
          inner_time_in_custody: "",
          notice_of_the_date_of_inspection: "",
          inner_notice_of_the_date_of_inspection: "",
          customs_fee_list: "",
          inspection_bill: "",
          delivery_remark: "", //节点备注
          in_custody_remark: "", //节点备注
          departure_remark: "", //节点备注
          landing_remark: "", //节点备注
          sailing_remark: "", //节点备注
          port_remark: "", //节点备注
          driving_remark: "", //节点备注
          arrival_remark: "", //节点备注
          customs_declaration_remark: "", //节点备注
          customs_clearance_remark: "", //节点备注
          delivery_time_to_warehouse_remark: "", //节点备注
          completion_time_of_the_goods_remark: "", //节点备注
          notice_of_the_date_of_inspection_remark: "", //节点备注
          release_remark: "", //节点备注
          ba0: "",
          ba1: "",
          ba2: "",
          ba3: "",
          ba4: "",
          ba5: "",
          ba6: "",
          ba7: "",
          ba8: "",
          ba9: "",
          ba10: "",
          ba11: "",
          ba12: "",
          ba13: "",
          ba14: "",
          ba15: "",
        },
        // 批次二
        batchAttribute2: {
          "airlines": "",
          "air_waybill": "",
          "shipping_company": "",
          "railway_companies": "",
          "extraction_company": "",
          "bill_of_lading_weight": "",
          "billing_weight": "",
          "extraction_time": "",
          "agency_company": "",
          "carriers": "",
          "inspection_fee_charged": "",
          "inspection_notice": "",
          "departure_time": "",
          "inner_departure_time": "",
          "sailing_time": "",
          "inner_sailing_time": "",
          "driving_time": "",
          "inner_driving_time": "",
          "landing_time": "",
          "inner_landing_time": "",
          "port_time": "",
          "inner_port_time": "",
          "arrival_time": "",
          "inner_arrival_time": "",
          "completion_time_of_the_goods": "",
          "inner_completion_time_of_the_goods": "",
          "delivery_time": "",
          "inner_delivery_time": "",
          "transport_vehicles": "",
          "transport_drivers": "",
          "customs_declaration_enddate": "",
          "inner_customs_declaration_enddate": "",
          "customs_declaration_customs": "",
          "customs_clearance_enddate": "",
          "inner_customs_clearance_enddate": "",
          "customs_clearance_customs": "",
          "release_date": "",
          "inner_release_date": "",
          "delivery_time_to_warehouse": "",
          "inner_delivery_time_to_warehouse": "",
          "time_in_custody": "",
          "inner_time_in_custody": "",
          "notice_of_the_date_of_inspection": "",
          "inner_notice_of_the_date_of_inspection": "",
          "customs_fee_list": "",
          "inspection_bill": "",
          "delivery_remark": "", //节点备注
          "in_custody_remark": "", //节点备注
          "departure_remark": "", //节点备注
          "landing_remark": "", //节点备注
          "sailing_remark": "", //节点备注
          "port_remark": "", //节点备注
          "driving_remark": "", //节点备注
          "arrival_remark": "", //节点备注
          "customs_declaration_remark": "", //节点备注
          "customs_clearance_remark": "", //节点备注
          "delivery_time_to_warehouse_remark": "", //节点备注
          "completion_time_of_the_goods_remark": "", //节点备注
          "notice_of_the_date_of_inspection_remark": "", //节点备注
          "release_remark": "", //节点备注
          "ba0": "",
          "ba1": "",
          "ba2": "",
          "ba3": "",
          "ba4": "",
          "ba5": "",
          "ba6": "",
          "ba7": "",
          "ba8": "",
          "ba9": "",
          "ba10": "",
          "ba11": "",
          "ba12": "",
          "ba13": "",
          "ba14": "",
          "ba15": ""
        }
      },
      rowData: {},
      extractionCompanyList: [],
      fileListI: [],
      fileListC: [],
      customsDeclarationList: [],
      customsDeclarationList2: [],
      vehicleData: [],
      customsFeeList:[],
      driverData: [],
      conditions: {},
      sellerTracks: []
    }
  },
  created() {
    this.conditions = JSON.parse(sessionStorage.getItem("batch_conditions"))
    this.editForm.channelType = this.$route.query.channelType
    this.id = this.$route.query.id

    setTimeout(() => {
      this.initVehicle();
      this.initDriver()
      this.onSubmit(this.conditions)
      this.loadCustoms("CUSTOMS_BROKER");
      this.loadCustoms("BROKER");
      this.loadOrderIds();
      this.loadfbaCodeData();
      this.querySellerTrack()

    }, 500)
  },
  methods: {
    // 查询seller端轨迹
    querySellerTrack(){
      this.$request1({
        method: 'post',
        url: `batch-track/query`,
        params: {
          batchId: this.id
        }
      }).then(res => {
        if(res.data.success){
          this.sellerTracks = res.data.data
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    // 删除轨迹
    delTrack(row){
      this.$confirm(`确定删除轨迹【${row.eventName}】吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$request1({
          method: 'post',
          url: `batch-track/delete-track`,
          data: {
            batchId: this.id,
            eventName: row.eventName,
            second: this.tabStatus == 0 ? false : true
          }
        }).then(res => {
          if(res.data.success){
            this.$message.success("操作成功")
            this.querySellerTrack()
            this.isDeleted = true
          }else{
            this.$message.error(res.data.message)
          }
        })

      })
      .catch(() => {
        console.log("close");
      });
    },
    getAliyunUrl(key){
      this.$request1({
        method: 'get',
        url: `download`,
        params: {
          ossKey: key
        }
      }).then(res => {
        if(res.data.success){
          window.open(res.data.data)
        }else{
          this.$message.error(res.data.message)
        }
      })

    },
    openUrl(url){
      if(url){
        window.open(url)
      }
    },

    loadOrderIds(){
      let _this = this
      _this.$request1
        .get(
          '/batchdetial',
          {
            params: {
              id: _this.id
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.theOrderIds = res.data.data.order.map(a => a.orderId)
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadfbaCodeData(){
      let _this = this
      this.$request1({
        method: 'get',
        // url: `${springHost}batch/files`,
        url: `batch/files`,
        params: {
          batchId: _this.id
        }
      }).then(res => {
        if(res.data.success){
          this.fbaCodeData = res.data.data            
        }else{
          this.$message.error(res.data.message)
        }
      }).catch(error => {
        console.log(error);
      });
    },
    fileButtonMark (name) {
      this.currentFileStr = name
    },
    fileChange1 (file, fileList) {
      // this.fileList1[this.currentFileStr] = file.raw
      let _this = this
      let form = new FormData()
      form.append('file', file.raw)

      this.$request1({
        method: 'post',
        // url: `${springHost}upload`,
        url: `upload`,
        data: form
      }).then(res => {
        if(res.data.success){

          if(_this.currentFileStr == 'uploadRef-chayan'){
            _this.editForm.batchAttribute.ba9 = res.data.ossKey
          }else if(_this.currentFileStr == 'uploadRef-chayan2'){
            _this.editForm.batchAttribute.ba6 = res.data.ossKey
          }else if(_this.currentFileStr == 'uploadRef-chayan3'){
            _this.editForm.batchAttribute2.ba9 = res.data.ossKey
          }else if(_this.currentFileStr == 'uploadRef-chayan4'){
            _this.editForm.batchAttribute2.ba6 = res.data.ossKey
          }else {
            let one = this.fbaCodeData.find(a => a.fbaCode==_this.currentFileStr)
            one.podOssKey = res.data.ossKey
            one.podUrl = res.data.ossUrl
          }
          
        }else{
          this.$message.error(res.data.errorInfo)
        }

        _this.$nextTick(() => {
          if(_this.$refs['uploadRef' + _this.currentFileStr]){
            _this.$refs['uploadRef' + _this.currentFileStr].clearFiles()
          }
          if(_this.$refs['uploadRef-chayan']){
            _this.$refs['uploadRef-chayan'].clearFiles()
          }
          if(_this.$refs['uploadRef-chayan2']){
            _this.$refs['uploadRef-chayan2'].clearFiles()
          }
          if(_this.$refs['uploadRef-chayan3']){
            _this.$refs['uploadRef-chayan3'].clearFiles()
          }
          if(_this.$refs['uploadRef-chayan4']){
            _this.$refs['uploadRef-chayan4'].clearFiles()
          }
        });
          
      }).catch(error => {
        console.log(error);
      });

    },
    handleRemove1 (file, fileList) {
      this.delPcsFileMap(file.raw.name)
    },
    delPcsFileMap (name) {
      for (let key in this.fileList1) {
        if (this.fileList1[key].name == name) {
          delete this.fileList1[key]
        }
      }
    },
    searchTask(){

    },
    ...mapMutations([
      'setBatchRowData'
    ]),
    handleEditForm(row) {
      for(var key in row) {
        // console.log(key)
        if(key === 'batchAttribute') {
          row[key].forEach(item => {
            if(item.attributeKey === "transport_vehicles" || 
              item.attributeKey === "transport_drivers"){
              if(item.attributeValue && item.attributeValue !== "") {
                this.editForm.batchAttribute[item.attributeKey] = item.attributeValue.split(",")
              } else{
                this.editForm.batchAttribute[item.attributeKey] = []
              }
            } else if(item.attributeKey === "whether_the_inspection") {
              if(item.attributeValue === "true") {
                this.editForm.batchAttribute[item.attributeKey] = true
              } else if(item.attributeValue === "false"){
                this.editForm.batchAttribute[item.attributeKey] = false
              }
            } else if(item.attributeKey === "customs_fee_list") {
              this.editForm.batchAttribute[item.attributeKey] = item.attributeValue.split(",")
              this.customsFeeList =  this.editForm.batchAttribute.customs_fee_list;
            }
            else{
              this.editForm.batchAttribute[item.attributeKey] = item.attributeValue
            }
          })
        } else if(key === 'batchAttribute2') {
          row[key].forEach(item => {
            if(item.attributeKey === "transport_vehicles" || 
              item.attributeKey === "transport_drivers"){
              if(item.attributeValue && item.attributeValue !== "") {
                this.editForm.batchAttribute2[item.attributeKey] = item.attributeValue.split(",")
              } else{
                this.editForm.batchAttribute2[item.attributeKey] = []
              }
            } else if(item.attributeKey === "whether_the_inspection") {
              if(item.attributeValue === "true") {
                this.editForm.batchAttribute2[item.attributeKey] = true
              } else if(item.attributeValue === "false"){
                this.editForm.batchAttribute2[item.attributeKey] = false
              }
            } else if(item.attributeKey === "customs_fee_list") {
              this.editForm.batchAttribute2[item.attributeKey] = item.attributeValue.split(",")
              this.customsFeeList =  this.editForm.batchAttribute2.customs_fee_list;
            }
            else{
              this.editForm.batchAttribute2[item.attributeKey] = item.attributeValue
            }
          })
        }else{
          this.editForm[key] = row[key]
        }
      }
    },
    toFixed(num, len) {
      if (!num || isNaN(num)) {
        return "";
      }
      var times = Math.pow(10, len);
      var des = num * times + 0.5;
      return parseInt(des, 10) / times;
    },
    uploadFileCustomsFeeList(file, fileList) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("batchId", this.editForm.id);
      formData.append("key", "customs_fee_list");
      this.$request1
        .post(
          '/batch-operation/upload/',
          formData,
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.status == 413) {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message:
                "Excel文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          }
          if (res.data.success) {
            _this.editForm.batchAttribute.customs_fee_list = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          if (error.response.status === 413) {
            _this.fileListC = [];
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    uploadFileInspectionBill(file, fileList) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("batchId", this.editForm.id);
      formData.append("key", "inspection_bill");
      this.$request1
        .post(
          '/batch-operation/upload/',
          formData,
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.status == 413) {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message:
                "Excel文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          }
          if (res.data.success) {
            _this.editForm.batchAttribute.inspection_bill = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          if (error.response.status === 413) {
            _this.fileListI = [];
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    getFileUrl(row, type) {
      return (
        '/batch-operation/upload/' +
        "?batchId=" +
        row.id +
        "&key=" +
        type
      );
    },
    loadCustoms(customsType) {
      //报关行
      this.$request1({
        method: 'GET',
        url: '/customs/load',
        params: {
          customsType: customsType,
          customsName: "",
          currentPage: 1,
          pageSize: 10000
        }
      })
        .then(response => {
          if (customsType == "CUSTOMS_BROKER") {
            this.customsDeclarationList = response.data.data;
          } else if (customsType == "BROKER") {
            this.customsDeclarationList2 = response.data.data;
          }
        })
        .catch(error => {});
    },
    initVehicle(licensePlate) {
      this.$request1({
        method: "GET",
        url: '/system/vehicle/queryLicensePlate',
        params: {
          licensePlate: licensePlate,
          currentPage: 1,
          pageSize: 10000
        }
      })
        .then(response => {
          let vehicleList = response.data.data;
          // console.log('vehicleList')
          // console.log(vehicleList)
          if (vehicleList && vehicleList.length > 0) {
            this.vehicleData = vehicleList;
          } else {
            this.vehicleData = [];
          }
        })
        .catch(error => {});
    },
    initDriver(name) {
      this.$request1({
        method: 'GET',
        url: '/system/driver/query',
        params: {
          name: name,
          currentPage: 1,
          pageSize: 10000
        }
      })
        .then(response => {
          // console.log('response.data.data')
          // console.log(response.data.data)
          if (response.data.data && response.data.data.length > 0) {
            this.driverData = response.data.data;
          } else {
            this.driverData = [];
          }
        })
        .catch(error => {});
    },
    //搜索
    onSubmit(conditions) {
      let batch = [];
      conditions.batchIdTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          batch.push(d);
        }
      });
      let search = [];
      conditions.searchTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          search.push(d);
        }
      });
      let params = {
        done: conditions.isDone === "已完成",
        channelType: conditions.status,
        transportCapacityId: conditions.capacity,
        batchNumber: [this.id],
        search: search,
        containerNumber: conditions.container,
        orderId: conditions.order,
        startDate: conditions.startDate,
        endDate: conditions.endDate,
        currentPage: conditions.currentPage,
        pageSize: conditions.pageSize
      }
      this.$request1
        .post(
          '/batch/query',
          params,
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.success) {
            let tableData = res.data.data.batchRichValues;
            tableData.find((value, index, tableData) => {
              if(value.id === this.id) {
                this.rowData = value
              }
            })
            this.handleEditForm(this.rowData)
          } else {
            this.$notify.error({
              title: '系统错误',
              message: `当前批次号：${this.id} 查询失败，请返回批次列表重新尝试或通知管理员！`
            });
          }
        })
        .catch(function(error) {});
    },
    getDownloadUrl(fileType) {
      let _this = this;
      let _fileName = _this.editForm.batchAttribute[fileType]
      if (!_fileName || _fileName == "") {
        _this.$message.error("请先上传文件");
        return false;
      }
      this.$request1
        .post(
          '/batch-operation/download/' + _fileName + ''
        )
        .then(res => {
          if (res.data.success) {
            window.location.href = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {});
    },
    getCustomsDownloadUrl(fileName) {
      let _this = this;
      let _fileName = fileName; //true 说明编辑窗口打开，false 说明在列表页
      if (!_fileName || _fileName == "") {
        _this.$message.error("请先上传文件");
        return false;
      }
      this.$request1
        .post(
          '/batch-operation/download/' + _fileName + ''
        )
        .then(res => {
          if (res.data.success) {
            window.location.href = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteFile(index,fileName, batchId, key) {
      let _this = this;
      let _fileName = fileName; //true 说明编辑窗口打开，false 说明在列表页
      if (!_fileName || _fileName == "") {
        _this.$message.error("请先上传文件");
        return false;
      }
      this.$request1({
        method: 'DELETE',
        url: '/batch-operation/' + _fileName + '/' + batchId + '/' + key + '',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            _this.customsFeeList.splice(index,1)
            _this.editForm.batchAttribute.customs_fee_list = _this.customsFeeList
            this.$notify.success({
              title: "成功",
              message: "删除成功"
            });
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {});
    },
    //保存
    handleSave() {

      let _this = this;
      let row = this.rowData
      for (let _key in this.editForm) {
        if (_key == "batchAttribute") {
          row[_key] = new Array();
          for (let _atkey in this.editForm.batchAttribute) {
            if (this.editForm.batchAttribute[_atkey] instanceof Array) {
              if (this.editForm.batchAttribute[_atkey].length > 0) {
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: this.editForm.batchAttribute[_atkey].toString()
                });
              } else {
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: ""
                });
              }
            } else {
              if (_atkey == "whether_the_inspection") {
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: this.editForm.batchAttribute[_atkey]
                    ? "true"
                    : "false"
                });
              } else {
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: this.editForm.batchAttribute[_atkey]
                });
              }
            }
          }
        } else {
          row[_key] = this.editForm[_key];
        }
      }
      let attributes = new Object();
      row.batchAttribute.forEach((d, i) => {
        attributes[d.attributeKey] = d.attributeValue;
      });

      // 从星邮发送文件到多发货
      let form3 = {
        batchId: this.editForm.id,
        chayan1: _this.editForm.batchAttribute.ba9,
        chayan2: _this.editForm.batchAttribute.ba6,
        chayan3: _this.editForm.batchAttribute2.ba9,
        chayan4: _this.editForm.batchAttribute2.ba6,
        fbaCodeDatas: _this.fbaCodeData
      }
      
      this.$request1({
        method: 'post',
        url: `batch/sync-files`,
        data: form3
      }).then(res => {
        if(res.data.success){
          _this.$message.success("操作成功： 同步文件到多发货");
        }else{
          this.$message.error(res.data.message)
        }
      })


      // 保存POD
      this.$request1({
        method: 'post',
        url: `batch/files`,
        data: this.fbaCodeData
      }).then(res => {
        if(res.data.success){
          _this.$message.success("操作成功： 保存POD文件");
        }else{
          this.$message.error(res.data.message)
        }
      })
      // return;

      this.$request1
        .post(
          '/batch-operation',
          {
            id: this.editForm.id,
            remarks: this.editForm.remarks,
            attributes: JSON.stringify(attributes),
            attributes2: JSON.stringify(this.editForm.batchAttribute2),
            orderIds2: this.editForm.orderIds2
          }
        )
        .then(res => {
          if(res.data.success) {
            this.onSubmit(this.conditions)
            let batchAttribute = []
            this.rowData.batchAttribute.forEach((item, index) => {
              if(item.attributeValue !== "") {
                batchAttribute.push(item)
              }
            })
            this.rowData.batchAttribute = batchAttribute
            this.setBatchRowData(this.rowData)
            // console.log('ooo')
            // console.log(this.rowData)
            this.$router.push('/orderoperation/batchoperation')
          }
          else {
             this.$message.error(res.data.message)
          }
        })  
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-demo{
  margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/EditBatchOperation.vue